module.exports = __webpack_public_path__ + "img/graduation-hat.31773838.png";